import React from "react";
import Style from "./FinishedPeykRequest.module.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faBicycle,
  faMapMarkedAlt,
  faPhone,
} from "@fortawesome/free-solid-svg-icons";
import { separate } from "../../Functions/NumberSeprator";
import moment from "moment-jalaali";
const FinishedPeykRequest = ({ data }) => {
  return (
    <section className={Style.RequestSectionHolder}>
      <p className={Style.HeaderOfSection}>
        <span>
          {" "}
          <FontAwesomeIcon icon={faBicycle} /> درخواست پیک
        </span>
        <span>شماره سفارش:{data?.id}</span>
      </p>
      <div className={Style.locationHolder}>
        <p>
          <span>نام فرستنده:</span>
          {data?.delivery_routes[0]?.name}
        </p>
        <p>
          <span>شماره فرستنده:</span>
          <a href={`tel:${data?.delivery_routes[0]?.phone}`}>
            {data?.delivery_routes[0]?.phone} <FontAwesomeIcon icon={faPhone} />
          </a>
        </p>
        <p>
          <span>مبدا:</span>
          {data?.delivery_routes[0]?.description}
        </p>
      </div>
      <div className={Style.locationHolder}>
        <p>
          <span>نام گیرنده:</span>
          {data?.delivery_routes[1]?.name}
        </p>
        <p>
          <span>شماره گیرنده:</span>
          <a href={`tel:${data?.delivery_routes[1]?.phone}`}>
            {data?.delivery_routes[1]?.phone} <FontAwesomeIcon icon={faPhone} />
          </a>
        </p>
        <p>
          <span>مقصد:</span>
          {data?.delivery_routes[1]?.description}
        </p>
      </div>
      {data?.delivery_routes[2] && (
        <div className={Style.locationHolder}>
          <p>
            <span>نام گیرنده دوم:</span>
            {data?.delivery_routes[2]?.name}
          </p>
          <p>
            <span>شماره گیرنده دوم:</span>
            <a href={`tel:${data?.delivery_routes[2]?.phone}`}>
              {data?.delivery_routes[2]?.phone}{" "}
              <FontAwesomeIcon icon={faPhone} />
            </a>
          </p>
          <p>
            <span>مقصد دوم:</span>
            {data?.delivery_routes[2]?.description}
          </p>
        </div>
      )}

      <div className={Style.locationHolder}>
        <p>
          <span>نام درخواست دهنده:</span>
          {data?.requested_user_name}
        </p>
        <p>
          <span>شماره درخواست دهنده:</span>
          <a href={`tel:${data?.requested_user_phone}`}>
            {data?.requested_user_phone} <FontAwesomeIcon icon={faPhone} />
          </a>
        </p>
        <p>
          <span>نوع وسیله:</span>
          {data?.category}
        </p>
        <p>
          <span>توضیحات وسیله:</span>
          {data?.product_description}
        </p>
        <p>
          <span>زمان درخواست وسیله:</span>
          {moment
            .unix(parseInt(data?.request_date))
            .format("jYYYY/jM/jD--hh:mm")}
        </p>
      </div>
      <div className={Style.locationHolder}>
        <p>
          <span> مسافت حدودی:</span>
          {data?.distance} متر
        </p>
      </div>
      <div className={Style.locationHolder}>
        <p>
          <span>کرایه:</span>
          <strong style={{ color: "green" }}>
            {separate(data?.driver)} تومان
          </strong>
        </p>
      </div>
      <div className={Style.locationHolder}>
        <p>
          <span>وضعیت پرداخت:</span>
          {data?.paid === "1" ? (
            <strong style={{ color: "green" }}>پرداخت شد</strong>
          ) : (
            <strong style={{ color: "red" }}>پرداخت نشده</strong>
          )}
        </p>
      </div>
      <div
        className={Style.locationHolder}
        style={{ borderBottom: "1px solid gray" }}
      >
        <p>
          <span>وضعیت درخواست:</span>
          {data?.status === "4"
            ? "مرسوله تحویل داده شد"
            : data?.status === "-2"
            ? "درخواست لغو شده"
            : data?.status === "-1"
            ? "توسط پیک کنسل شد!"
            : null}
        </p>
      </div>
    </section>
  );
};

export default FinishedPeykRequest;
